import _slicedToArray from "/codebuild/output/src196865849/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { useHover } from "../../../shared/hooks";
import TertiaryLink from "../../TertiaryLink";
import * as S from "./styles";
export var Article = function Article(_ref) {
  var e = _ref.image,
      t = _ref.imageAlt,
      r = _ref.title,
      a = _ref.copy,
      l = _ref.url;

  var _useHover = useHover(),
      _useHover2 = _slicedToArray(_useHover, 2),
      c = _useHover2[0],
      o = _useHover2[1],
      m = "object" == typeof e;

  return React.createElement(S.Article, {
    href: l,
    "aria-label": r,
    ref: c
  }, React.createElement(S.ImageWrapper, null, m ? e : React.createElement(S.Image, {
    alt: t,
    src: e
  })), React.createElement(S.ContentWrapper, null, React.createElement(S.Title, null, r), React.createElement(S.Copy, null, a), React.createElement(TertiaryLink, {
    isHovered: o
  }, "Read Article")));
};
export default React.memo(Article);